import report from "@report";
import { Select } from "antd";
import { useRef } from "react";
import { useAppSelector } from "@hooks/redux";
import { IconTriangleArrow } from "@icons/index";
import "./index.scss";
import { Trans } from "react-i18next";
const { Option } = Select;

const CountrySelector = (props: { onChange: Function; prefixValue?: string }) => {
  const domRef = useRef<HTMLDivElement>(null);
  const { regionOptions } = useAppSelector((state) => state.configReducer);

  return (
    <div
      ref={domRef}
      className="country-selector"
      onClick={(e) => {
        e.stopPropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <Select
        suffixIcon={<IconTriangleArrow />}
        // dropdownStyle={{ width: 95 }}
        popupMatchSelectWidth={false}
        onChange={(val) => {
          props.onChange(val);
          report.click({
            kalo_pos: "choose-phone-prefix",
            kalo_value: val,
          });
        }}
        getPopupContainer={() => domRef.current as HTMLElement}
        defaultValue={props.prefixValue && props.prefixValue !== "null" ? props.prefixValue : "US"}
      >
        {regionOptions.map((el: any) => {
          return (
            <Option value={el.value} key={el.name}>
              <div className="select-wrapper">
                <img className="nation-img" src={el.icon} alt=""></img>
                <Trans>{el.name}</Trans>
              </div>
            </Option>
          );
        })}
      </Select>
    </div>
  );
};

export default CountrySelector;
